var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStateInspector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00292969 3.6C0.00292969 2.71635 0.719274 2 1.60293 2H14.4032C15.2869 2 16.0032 2.71634 16.0032 3.6V12.3999C16.0032 13.2836 15.2869 13.9999 14.4032 13.9999H1.60293C0.719276 13.9999 0.00292969 13.2836 0.00292969 12.3999V3.6ZM1.60293 3.2C1.38202 3.2 1.20293 3.37909 1.20293 3.6V12.3999C1.20293 12.6208 1.38202 12.7999 1.60293 12.7999H14.4032C14.6241 12.7999 14.8032 12.6208 14.8032 12.3999V3.6C14.8032 3.37909 14.6241 3.2 14.4032 3.2H1.60293Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91368 5.56495C7.1539 5.7932 7.1636 6.17298 6.93535 6.4132L5.42767 7.9999L6.93535 9.58661C7.1636 9.82683 7.1539 10.2066 6.91368 10.4349C6.67346 10.6631 6.29369 10.6534 6.06543 10.4132L4.16504 8.4132C3.94499 8.18161 3.94499 7.8182 4.16504 7.58661L6.06543 5.58661C6.29369 5.34639 6.67346 5.33669 6.91368 5.56495Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.08675 5.5649C8.84651 5.79314 8.83677 6.17291 9.065 6.41315L10.5724 7.9999L9.065 9.58665C8.83677 9.8269 8.84651 10.2067 9.08675 10.4349C9.32699 10.6631 9.70677 10.6534 9.935 10.4132L11.835 8.41315C12.055 8.18157 12.055 7.81823 11.835 7.58665L9.935 5.58665C9.70677 5.34641 9.32699 5.33667 9.08675 5.5649Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateInspector);
export default __webpack_public_path__ + "static/media/state-inspector.73dafd4941fbe9821cf20a3f3f5de2ac.svg";
export { ForwardRef as ReactComponent };